// extracted by mini-css-extract-plugin
module.exports = {"PageCardList__List":"PageCardList_PageCardList__List__FPn_s","PageCardList__Item":"PageCardList_PageCardList__Item__nRBa_"};